import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSerializer } from '@angular/router';
import { CustomUrlSerializer } from '@app/custom-url-serializer';
import { AuthGuard } from '@app/shared/guards/auth-guard';
import { shouldUseHashRouting } from '@app/utils/routing-utils';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  // Note: Guest meeting routes (meeting/:meetingId/join) are now handled by GuestAppModule
  // and never reach this router. They use a completely separate app bootstrap.
  {
    path: 'preferences',
    loadChildren: () => import('./preferences/preference.module').then((m) => m.PreferenceModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'logout',
    loadComponent: () =>
      import('@app/core/components/logout-message/logout-message.component').then((c) => c.LogoutMessageComponent),
  },
  {
    path: 'critical-update',
    loadComponent: () =>
      import('@app/core/components/critical-update-message/critical-update-message.component').then(
        (c) => c.CriticalUpdateMessageComponent
      ),
  },
  {
    path: 'browser-auth',
    loadComponent: () =>
      import('@app/core/components/browser-auth-prompt/browser-auth-prompt.component').then(
        (c) => c.BrowserAuthPromptComponent
      ),
  },
  {
    path: 'not-provisioned',
    loadComponent: () =>
      import('@app/core/components/not-provisioned/not-provisioned.component').then((c) => c.NotProvisionedComponent),
  },
  {
    path: '',
    loadChildren: () => import('./core/core.module').then((m) => m.CoreModule),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: shouldUseHashRouting() })],
  exports: [RouterModule],
  providers: [{ provide: UrlSerializer, useClass: CustomUrlSerializer }],
})
export class AppRoutingModule {}
